/** Backend AppointmentScheduleRangeType enum values (days). */
export const APPOINTMENT_SCHEDULE_RANGE = {
  ONE_WEEK: 7,
  TWO_WEEKS: 14,
  THREE_WEEKS: 21,
  ONE_MONTH: 30,
};

export const DEFAULT_APPOINTMENT_SCHEDULE_RANGE = APPOINTMENT_SCHEDULE_RANGE.ONE_MONTH;

export const APPOINTMENT_SCHEDULE_RANGE_OPTIONS = [
  { value: APPOINTMENT_SCHEDULE_RANGE.ONE_WEEK, labelKey: "appointment_schedule_range_one_week" },
  { value: APPOINTMENT_SCHEDULE_RANGE.TWO_WEEKS, labelKey: "appointment_schedule_range_two_weeks" },
  { value: APPOINTMENT_SCHEDULE_RANGE.THREE_WEEKS, labelKey: "appointment_schedule_range_three_weeks" },
  { value: APPOINTMENT_SCHEDULE_RANGE.ONE_MONTH, labelKey: "appointment_schedule_range_one_month" },
];

/** Backend AppointmentSlotGenerationMode enum values. */
export const APPOINTMENT_SLOT_GENERATION_MODE = {
  AUTOMATIC_WEEKLY: 0,
  ONE_TIME: 1,
};

export const APPOINTMENT_SLOT_GENERATION_MODE_OPTIONS = [
  {
    value: APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY,
    labelKey: "appointment_slot_generation_mode_automatic",
    descriptionKey: "appointment_slot_generation_mode_automatic_hint",
  },
  {
    value: APPOINTMENT_SLOT_GENERATION_MODE.ONE_TIME,
    labelKey: "appointment_slot_generation_mode_one_time",
    descriptionKey: "appointment_slot_generation_mode_one_time_hint",
  },
];

const SCHEDULE_RANGE_BY_NAME = {
  ONEWEEK: APPOINTMENT_SCHEDULE_RANGE.ONE_WEEK,
  ONE_WEEK: APPOINTMENT_SCHEDULE_RANGE.ONE_WEEK,
  TWOWEEKS: APPOINTMENT_SCHEDULE_RANGE.TWO_WEEKS,
  TWO_WEEKS: APPOINTMENT_SCHEDULE_RANGE.TWO_WEEKS,
  THREEWEEKS: APPOINTMENT_SCHEDULE_RANGE.THREE_WEEKS,
  THREE_WEEKS: APPOINTMENT_SCHEDULE_RANGE.THREE_WEEKS,
  ONEMONTH: APPOINTMENT_SCHEDULE_RANGE.ONE_MONTH,
  ONE_MONTH: APPOINTMENT_SCHEDULE_RANGE.ONE_MONTH,
};

export function normalizeScheduleRange(value) {
  if (value == null || value === "") {
    return DEFAULT_APPOINTMENT_SCHEDULE_RANGE;
  }

  const n = Number(value);
  if (APPOINTMENT_SCHEDULE_RANGE_OPTIONS.some((o) => o.value === n)) {
    return n;
  }

  const byName = SCHEDULE_RANGE_BY_NAME[String(value).toUpperCase().replace(/\s/g, "")];
  if (byName) return byName;

  return DEFAULT_APPOINTMENT_SCHEDULE_RANGE;
}

export function normalizeSlotGenerationMode(value) {
  if (value == null || value === "") {
    return APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY;
  }

  const n = Number(value);
  if (n === APPOINTMENT_SLOT_GENERATION_MODE.ONE_TIME) {
    return APPOINTMENT_SLOT_GENERATION_MODE.ONE_TIME;
  }
  if (n === APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY) {
    return APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY;
  }

  const key = String(value).toUpperCase().replace(/\s/g, "");
  if (key === "ONETIME" || key === "ONE_TIME") {
    return APPOINTMENT_SLOT_GENERATION_MODE.ONE_TIME;
  }

  return APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY;
}

export function readScheduleRangeFromDto(dto) {
  if (!dto) return DEFAULT_APPOINTMENT_SCHEDULE_RANGE;
  return normalizeScheduleRange(
    dto.appointmentScheduleRange ?? dto.AppointmentScheduleRange
  );
}

export function readSlotGenerationModeFromDto(dto) {
  if (!dto) return APPOINTMENT_SLOT_GENERATION_MODE.AUTOMATIC_WEEKLY;
  return normalizeSlotGenerationMode(
    dto.appointmentSlotGenerationMode ?? dto.AppointmentSlotGenerationMode
  );
}

/** Values accepted by `sessionDurationMinutes`; `null` means the profession default. */
export const SESSION_DURATION_OPTIONS = [15, 20, 30, 45, 60];

export const DEFAULT_SESSION_DURATION = 30;

export function normalizeSessionDuration(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return SESSION_DURATION_OPTIONS.includes(n) ? n : null;
}

/** Doctor override (may be null). */
export function readSessionDurationFromDto(dto) {
  if (!dto) return null;
  return normalizeSessionDuration(dto.sessionDurationMinutes ?? dto.SessionDurationMinutes);
}

/** Duration actually used for slots: doctor override → profession default → 30. */
export function readEffectiveSessionDurationFromDto(dto, professionDefault) {
  const effective = Number(dto?.effectiveSessionDurationMinutes ?? dto?.EffectiveSessionDurationMinutes);
  if (effective > 0) return effective;
  return readSessionDurationFromDto(dto) ?? (Number(professionDefault) > 0 ? Number(professionDefault) : DEFAULT_SESSION_DURATION);
}
